import { ExcludedBorrowerOverview } from '@oaknorth/api-polaris';
import { SimpleCard, StatsHeader } from '@oaknorth/component-core-v2';
import { BorrowerIRRTooltip } from '@oaknorth/domain-vr';
import { FormatValue, Money, T } from '@oaknorth/util-intl';

export interface BorrowerDetailsProps {
  borrower?: ExcludedBorrowerOverview;
  isLoading?: boolean;
}

export function BorrowerDetails({ borrower, isLoading }: BorrowerDetailsProps) {
  return (
    <SimpleCard>
      <StatsHeader
        entity={borrower}
        isLoading={isLoading}
        stats={[
          {
            label: T`vr.borrowerDetails.exposure.label`,
            value: (borrower) =>
              borrower.exposure ? <FormatValue value={new Money(borrower.exposure, 'USD')} /> : '-',
          },
          {
            label: (
              <>
                {T`vr.borrowerDetails.irr.label`}
                <BorrowerIRRTooltip />
              </>
            ),
            value: (borrower) => <>{borrower.internal_risk_rating ?? '-'}</>,
          },

          {
            label: T`vr.borrowerDetails.relationshipManager.label`,
            value: (borrower) => <>{borrower.relationship_manager || '-'}</>,
          },
        ]}
      />
    </SimpleCard>
  );
}
